export const Confirmation = () => {
  return (
    <div className="main about">
      <div className="aside">
        <div></div>
      </div>

      <div className="content has-aside static">
        <h1>You are now registered for Flintt.</h1>
        <p>
          We've emailed you with a link to verify your account. Please check
          your spam folder.
        </p>
      </div>
    </div>
  );
};
